
const options = [
  "Constituição",
  "Tratados",
  "Lei Complementar",
  "Lei Federal",
  "Medida Provisória",
  "Decretos",
  "PL no Senado",
  "PL na Câmara",
  "Consulta Pública",
  "Outros"
];

const values = [
  "constituicao",
  "tratados",
  "lei-complementar",
  "leis-federais",
  "medida-provisoria",
  "decretos",
  "pl-senado",
  "pl-camara",
  "consultas-publicas",
  "outros",
]


const types = options.map((v, i) => {return {option: v, value: values[i]}});

export default types;